'use client';
import * as React from 'react';

const ErrorDetails = ({ open, error, errorInfo, msg = 'Something went wrong!' })=>/*#__PURE__*/ React.createElement("div", null, typeof msg === 'string' ? /*#__PURE__*/ React.createElement("h2", null, msg) : msg, /*#__PURE__*/ React.createElement("details", {
        style: {
            whiteSpace: 'pre-wrap'
        },
        open: open
    }, /*#__PURE__*/ React.createElement("summary", null, "Error details"), /*#__PURE__*/ React.createElement("p", null, error && error.toString()), /*#__PURE__*/ React.createElement("h4", {
        className: "swan-mt-4"
    }, "Stack trace:"), /*#__PURE__*/ React.createElement("div", null, errorInfo && errorInfo.componentStack)));
class ErrorBoundary extends React.Component {
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        });
    }
    render() {
        const { children, fallback, forceShowError, errorDetailMsg } = this.props;
        if (!this.state.error) {
            return children;
        }
        return /*#__PURE__*/ React.createElement(React.Fragment, null, fallback, forceShowError || !fallback ? /*#__PURE__*/ React.createElement(ErrorDetails, {
            error: this.state.error,
            errorInfo: this.state.errorInfo,
            open: !fallback,
            msg: errorDetailMsg
        }) : null);
    }
    constructor(props){
        super(props);
        this.state = {
            error: null,
            errorInfo: null
        };
    }
}

export { ErrorBoundary };
